import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Puhelinnumero',
      placeholder: 'Syötä puhelinnumero',
    },
    email: {
      label: 'Sähköpostiosoite',
      placeholder: 'Syötä sähköpostiosoite',
    },
  },
  channel_chooser: {
    title: 'Lähetä koodi',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Ilmainen, nopein toimitus',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Tavallinen tekstiviesti',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'Sähköposti',
      subtitle: 'Koodi suoraan saapuneisiin',
    },
  },
  otp: {
    title: 'Syötä vahvistuskoodi',
    send_code: 'Lähetä koodi',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Lähetetty <strong>WhatsAppilla</strong> numeroon <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Lähetetty <strong>tekstiviestillä</strong> numeroon <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Lähetetty <strong>sähköpostitse</strong> osoitteeseen <strong>{{phone}}</strong>',
    },
    sent_to: 'Lähetetty',
    resend: {
      title: 'Etkö saanut koodia?',
      countdown: 'Lähetä uudelleen',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Etkö saanut koodia sähköpostitse?',
          button: 'Lähetä uudelleen sähköpostitse',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Etkö saanut koodia?',
          button: 'Lähetä uudelleen tekstiviestillä',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Etkö saanut koodia?',
          button: 'Lähetä uudelleen WhatsAppilla',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Lähetä sen sijaan tekstiviestillä',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Lähetä sen sijaan WhatsAppilla',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Vahvistuskoodin sisältävä viesti on lähetetty puhelimeesi. Syötä koodi jatkaaksesi.',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Syötä tähän osoitteeseen lähetetty koodi: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Vahvistuskoodin sisältävä WhatsApp-viesti on lähetetty puhelimeesi. Syötä koodi jatkaaksesi.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Vinkki: tarkista saapuneet ja roskapostikansio.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Huomio — koodi lähetetään osoitteesta <strong>{{sender}}</strong>, teknologiakumppaniltamme.',
    business_account: 'Yritystili',
    message: '<strong>123456</strong> on vahvistuskoodisi. Älä jaa tätä koodia kenellekään.',
  },
  error_messages: {
    frequent_requests:
      'Tarkista viestisi. Koodi on jo lähetetty annettuun numeroon. Jos et saanut sitä, tarkista puhelinnumero tai yritä uudelleen 10 minuutin kuluttua.',
    frequent_requests_email:
      'Tarkista saapuneet ja roskapostikansio. Koodi on jo lähetetty kyseiseen osoitteeseen. Jos se ei ole saapunut, yritä uudelleen 10 minuutin kuluttua.',
    invalid_number: 'Virheellinen numero. Yritä uudelleen.',
    invalid_email: 'Koodia ei voitu lähettää tähän sähköpostiosoitteeseen. Tarkista osoite ja yritä uudelleen.',
    email_not_on_file:
      'Tällä puhelinnumerolla on jo tili ilman sähköpostiosoitetta. Ota yhteyttä osoitteeseen {{support_email}} lisätäksesi sen — siihen asti emme voi lähettää koodeja tälle numerolle sähköpostitse.',
    turnstile_required: 'Suorita vahvistus loppuun ennen uuden koodin pyytämistä.',
    generic_error: 'Hups, jotain meni pieleen. Päivitä sivu ja yritä uudelleen.',
    change_phone_number_unsuccessful: 'Puhelinnumeron vaihto epäonnistui. Yritä uudelleen.',
  },
  toasts: {
    code_sent: 'Koodi lähetetty',
  },
};
